// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"be0400f5","197":"1dd95e42","254":"4a4f56c7","292":"1aaafec8","561":"8cf10afe","600":"2522237c","737":"ca3a86f2"}[chunkId] + ".chunk.css";
};